/* eslint-disable no-console */
import wrapper from 'wrapper';
import trackScrollPosition from './utils/trackScrollPosition';
import FilterButtons from './components/filter-buttons/filter-buttons';
import Profile from './components/profile/profile';
import BackToTopBtn from './components/back-to-top-button/back-to-top';

// add tracking to OJs
wrapper.selectAll('.onward-journey').forEach((li) => {
    li.addEventListener('click', () => wrapper.trackUserAction('onward journey clicked', li.querySelector('a').href));
});

wrapper.markPageAsLoaded();
new FilterButtons();
new Profile();
new BackToTopBtn();

__lazyLoad();

wrapper.onOptimizedScroll(() => {
    trackScrollPosition();
});
